export const OPTIONAL_ANONYMITY_LEARN_MORE_TOOLTIP = 'optional-anonymity:learn-more';
